<!-- 销售数据统计 -->
<template>
  <div>
    <!-- header -->
    <div class="container">
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>销售情况</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 数据 -->
      <div class="data-header-box">
        <div class="data-header-li">
          <div class="data-li-top">商品情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.allProductCount }}种</div>
              <div class="text-p">在线商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.orderProductCount }}种</div>
              <div class="text-p">成交商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.yearProductCount }}种</div>
              <div class="text-p">本年上线商品</div>
            </div>
            <div class="li-text">
              <div class="text-h2">
                {{ catalogueData.effectiveOrderProductCount }}种
              </div>
              <div class="text-p">本年成交商品</div>
            </div>
          </div>
        </div>
        <div class="data-header-li">
          <div class="data-li-top">销售情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">
                {{ catalogueData.thisYearOrderAmount }}元
              </div>
              <div class="text-p">本年度销售额</div>
            </div>
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.mom }}%</div>
              <div class="text-p">
                <span>环比</span>
                <el-tooltip class="item" effect="dark" placement="bottom-start">
                  <div slot="content">
                    （本年度销售额 - 上年度销售额）/ 上年度销售额
                  </div>
                  <div class="title-text">?</div>
                </el-tooltip>
              </div>
            </div>
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.industryRank }}%</div>
              <div class="text-p">
                <span>超过同行业</span>
                <el-tooltip class="item" effect="dark" placement="bottom-start">
                  <div slot="content">
                    企业所在行业：{{ catalogueData.classificationName }}
                    <br />
                    在该会员所在行业内的公司、按照公司纬度分
                    <br />
                    组统计报告周期内未删除的、有效订单的销售
                    <br />
                    总金额，按照销售额升序排序，S%=排序序号
                    <br />
                    数 / (该行业有销售额的公司总数)
                  </div>
                  <div class="title-text">?</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="data-header-li">
          <div class="data-li-top">客户情况</div>
          <div class="data-li-content">
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.thisYearCount }}家</div>
              <div class="text-p">本年新增客户</div>
            </div>
            <div class="li-text">
              <div class="text-h2">{{ catalogueData.allCount }}家</div>
              <div class="text-p">累计成交客户</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 销售趋势分析 -->
    <div class="container myChart">
      <div class="flex">
        <span class="flex-h2">
          <img
            class="icon-list"
            src="@/assets/img/icon/list.png"
            title="销售趋势分析"
            alt=""
          />
          <span>销售趋势分析</span>
        </span>
        <el-form ref="form" :inline="true" :model="trendData">
          <el-form-item label="统计范围" style="margin: 0 20px">
            <el-select
              v-model="trendData.status"
              multiple
              collapse-tags
              style="width: 300px"
              placeholder="请选择产品目录"
            >
              <el-option
                v-for="item in categoryList"
                :key="item.lbbm"
                :label="item.lbmc"
                :value="item.lbbm"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button class="btn" @click="handleReset1">重置</el-button>
          <el-button class="btn" type="primary" @click="handleFilter1"
            >查询</el-button
          >
        </el-form>
      </div>
      <!-- echarts -->
      <div id="myChart1" :style="{ width: '100%', height: '350px' }"></div>
    </div>

    <!-- 商品销售规模地区排行 -->
    <div class="container" style="display: flex">
      <div class="flex" style="flex-direction: column">
        <span class="flex-h2">商品销售规模地区排行</span>
        <!-- <div class="region"></div> -->
        <div class="region">
          <!-- echarts -->
          <div id="myChart3" :style="{ width: '92%', height: '600px' }"></div>
          <div class="myChart3-btn">
            <div class="btn-li el-icon-plus" @click="handlePlus"></div>
            <div class="btn-li el-icon-refresh" @click="handleRefresh"></div>
            <div class="btn-li el-icon-minus" @click="handleMinus"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 品牌销售商城流量 -->
    <div v-show="mallPvUv.length" class="container myChart">
      <div class="flex">
        <span class="flex-h2">品牌销售商城流量</span>
        <el-form ref="form" :inline="true" :model="queryData">
          <el-form-item label="" style="margin: 0 20px">
            <el-select
              v-model="queryData.brandMallName"
              style="width: 200px"
              placeholder=""
              @change="changeMallPvUv"
            >
              <el-option
                v-for="item in mallPvUv"
                :key="item.brandMallName"
                :label="item.brandMallName"
                :value="item.brandMallName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查询时间" prop="time">
            <el-date-picker
              v-model="queryData.time"
              style="width: 300px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-button class="btn" @click="handleReset2">重置</el-button>
          <el-button class="btn" type="primary" @click="handleFilter2"
            >查询</el-button
          >
        </el-form>
      </div>
      <div id="myChart2" :style="{ width: '100%', height: '400px' }"></div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/user/index';
// import { provinces } from "../components/map.js";
import utils from '@/modules/projectA/utils/utils';
import china from '../components/china.json';

export default {
  data() {
    return {
      mapLayoutSize: 90,
      productFlowData: {
        time: '',
      },
      catalogueData: {
        classificationName: '',
        allCount: 0, // 所有客户数量
        thisYearCount: 0, // 本年新增客户数量
        thisYearOrderAmount: 0, // 本年度销售额
        industryRank: 0, // 超过同行业
        mom: 0, // 环比
        yearProductCount: 0, // 本年上线商品
        orderProductCount: 0, // 成交数量
        effectiveOrderProductCount: 0, // 本年成交商品数量
        allProductCount: 0, // 在线商品数量
      },
      myChart1: null,
      myChart2: null,
      myChart3: null,
      categoryList: [],
      pickerOptions: {
        // 监听每一次选择日期的事件
        onPick: ({ maxDate, minDate }) => {
          // 最大时间  最小时间
          this.choiceDate = minDate.getTime(); // 当选一个日期时 就是最小日期
          // // 如何选择了两个日期了，就把那个变量置空
          if (maxDate) this.choiceDate = '';
          this.minDate = minDate;
        },
        // 设置禁用状态  time是日历上的每一个时间
        disabledDate: (time) => {
          if (!this.minDate) return time.getTime() > Date.now();
          // 如果选择了一个日期
          if (this.choiceDate) {
            // 15天的时间戳
            const res = 29 * 24 * 3600 * 1000; // 这里如果乘以15相当于限制16天以内的  所以乘以14
            // 当前日期 - res = 15天之前
            const minTime = this.choiceDate - res;

            // 当前日期 + res = 15天之后
            const maxTime = this.choiceDate + res;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      trendData: {
        status: null,
      },
      option2: {
        // title: {
        //   text: '销售趋势分析',
        //   x: '1%',
        //   y: '0',
        //     color: '#333',
        //     fontSize: '20',
        // },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: 0,
          left: '90%',
          itemHeight: 12,
          itemWidth: 12,
          data: [''],
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 0,
          },
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          minInterval: 1, // y轴的刻度只显示整数
          axisLabel: {
            show: true,
            formatter: `{value} 元`, // 右侧Y轴文字显示
          },
        },

        // 直角坐标系内绘图网格
        grid: {
          top: '10%', // grid组件距上下左右的距离
          left: '5%',
          right: '5%',
          bottom: '2%',
          containLabel: true, // grid区域是否包含坐标轴的刻度标签。
        },
        series: [
          {
            name: '元',
            type: 'line',
            smooth: false, // 是否平滑
            symbolSize: 10,
            symbol: 'circle',
            itemStyle: {
              color: '#4080FF',
            },
          },
        ],
      },
      scopePages: [],
      saleProvince: null,
      mallPvUv: [],
      pvuvData: [],
      queryData: {
        time: [
          utils.formatDate(
            new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
            'yyyy-MM-dd'
          ),
          utils.formatDate(new Date(), 'yyyy-MM-dd'),
        ],
        startTime: '',
        endTime: '',
        brandMallName: '',
        pageSize: 1000,
      },
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    collapse: {
      immediate: true,
      handler(newVal) {
        console.log(newVal);
        setTimeout(() => {
          this.myChart1.resize();
          this.myChart2.resize();
          this.myChart3.resize();
        }, 1000);
      },
    },
  },
  async mounted() {
    this.queryConsumerCore();
    this.queryBrandMallPvUv();
    this.querySaleCore();
    this.queryProductCore();
    this.$echarts.registerMap('china', china);
    window.addEventListener('resize', () => {
      this.myChart1.resize();
      this.myChart2.resize();
      this.myChart3.resize();
    });
    this.myChartsOptionFun1();
    this.querySaleProvince();
  },
  methods: {
    async queryBrandMallPvUv() {
      const res = await api.queryBrandMallPvUv({});
      if (res.code == '200') {
        this.mallPvUv = res.data;
        if (this.mallPvUv.length) {
          this.queryData.brandMallName = this.queryData.brandMallName
            ? this.queryData.brandMallName
            : this.mallPvUv[0].brandMallName;
          this.pvuvData = this.mallPvUv.find(
            (item) => item.brandMallName == this.queryData.brandMallName
          ).pvuvList;
        }
        this.myChartsOptionFun2();
      }
    },

    async querySaleProvince() {
      const res = await api.querySaleProvince({});
      if (res.code == '200') {
        this.saleProvince = res.data;
        this.myChartsOptionFun3();
      }
    },

    handleMinus() {
      this.mapLayoutSize -= 5;
      if (this.mapLayoutSize <= 10) {
        this.mapLayoutSize = 10;
      }
      this.myChartsOptionFun3();
    },
    handleRefresh() {
      this.mapLayoutSize = 90;
      this.myChartsOptionFun3();
    },
    handlePlus() {
      this.mapLayoutSize += 5;
      this.myChartsOptionFun3();
    },
    getTimeDate() {
      const dataArr = [];
      const data = new Date();
      // let year = data.getFullYear();
      data.setMonth(data.getMonth() + 1, 1); // 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1); // 每次循环一次 月份值减1
        let m = data.getMonth() + 1;
        m = m < 10 ? `0${m}` : m;
        dataArr.push(`${data.getFullYear()}-${m}`);
      }
      return dataArr;
    },
    // 查询供应商客户情况核心数据
    async queryConsumerCore() {
      const res = await api.queryConsumerCore({});
      if (res.code == '200' && res.data.length) {
        this.catalogueData.allCount = res.data[0].allCount;
        this.catalogueData.thisYearCount = res.data[0].thisYearCount;
      }
    },
    // 查询供应商销售核心数据
    async querySaleCore() {
      const res = await api.querySaleCore({});
      if (res.code == '200' && res.data) {
        this.catalogueData.industryRank = res.data.industryRank * 100 || 0;
        this.catalogueData.thisYearOrderAmount =
          res.data.thisYearOrderAmount || 0;
        this.catalogueData.mom = res.data.mom ? res.data.mom * 100 : 0;
        this.catalogueData.classificationName =
          res.data.classificationName || '';
      }
    },
    // 查询供应商商品情况核心数据
    async queryProductCore() {
      const res = await api.queryProductCore({});
      if (res.code == '200' && res.data.length) {
        this.catalogueData.yearProductCount = res.data[0].yearProductCount;
        this.catalogueData.allProductCount = res.data[0].allProductCount;
        this.catalogueData.orderProductCount = res.data[0].orderProductCount;
        this.catalogueData.effectiveOrderProductCount =
          res.data[0].effectiveOrderProductCount;
      }
    },
    // 查询
    async handleFilter1() {
      if (!this.trendData.status.length) {
        this.trendData.status = [];
        this.myChartsOptionFun1();
      } else {
        const res = await api.querySaleMonth({});
        const arr = [];
        this.trendData.status.forEach((item2) => {
          res.data.forEach((item) => {
            if (item.lbbm == item2) {
              arr.push(item);
            }
          });
        });
        const dataList = this.getTimeDate().map((item) => {
          return {
            yearMonth: item,
            orderAmount: 0,
          };
        });
        dataList.forEach((item) => {
          arr.forEach((item2) => {
            if (item.yearMonth == item2.yearMonth) {
              item.orderAmount = item2.orderAmount;
            }
          });
        });
        this.option2.series[0].data = dataList.map((item) => item.orderAmount);
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
        this.myChart1.setOption(this.option2);
      }
    },
    // 重置
    handleReset1() {
      this.trendData.status = [];
      this.myChartsOptionFun1();
    },
    // 查询
    handleFilter2() {
      this.queryBrandMallPvUv();
      this.myChartsOptionFun2();
    },
    // 重置
    handleReset2() {
      this.queryBrandMallPvUv();
    },

    // 销售趋势分析
    async myChartsOptionFun1() {
      const res = await api.querySaleMonth({});
      if (res.code == '200') {
        const arr = res.data.map((item) => {
          return {
            lbbm: item.lbbm,
            lbmc: item.lbmc,
          };
        });
        this.categoryList = this.removeRepetition(arr);

        this.option2.xAxis.data = this.getTimeDate().reverse();
        const dataList = this.getTimeDate().map((item) => {
          return {
            yearMonth: item,
            orderAmount: 0,
          };
        });
        const mergeList = this.mergeArr(res.data);
        dataList.forEach((item) => {
          mergeList.forEach((item2) => {
            if (item.yearMonth == item2.yearMonth) {
              item.orderAmount = item2.orderAmount;
            }
          });
        });
        this.option2.series[0].data = dataList
          .map((item) => item.orderAmount)
          .reverse();
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
        this.myChart1.setOption(this.option2);
      }
    },

    // 去重
    removeRepetition(arr) {
      const obj = {};
      arr = arr.reduce(function (item, next) {
        obj[next.lbbm] ? '' : (obj[next.lbbm] = true && item.push(next));
        return item;
      }, []);
      return arr;
    },

    mergeArr(arr) {
      const newArr = [];
      arr.forEach((item) => {
        const dataItem = item;
        if (newArr.length > 0) {
          const filterValue = newArr.filter((v) => {
            return v.yearMonth == dataItem.yearMonth;
          });
          if (filterValue.length > 0) {
            newArr.forEach((n) => {
              if (n.yearMonth == filterValue[0].yearMonth) {
                n.orderAmount =
                  filterValue[0].orderAmount + dataItem.orderAmount;
              }
            });
          } else {
            newArr.push(dataItem);
          }
        } else {
          newArr.push(dataItem);
        }
      });
      return newArr;
    },

    // 商城销售流量
    async myChartsOptionFun2() {
      const option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '1%',
          left: '40%',
          fontSize: 16,
          icon: 'roundRect',
          itemHeight: 18,
          itemWidth: 30,
          data: ['PV', 'UV'],
        },
        xAxis: {
          axisLabel: {
            interval: 0,
            rotate: 40,
          },
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          minInterval: 1, // y轴的刻度只显示整数
        },

        // 直角坐标系内绘图网格
        grid: {
          top: '20%', // grid组件距上下左右的距离
          left: '5%',
          right: '5%',
          bottom: '2%',
          containLabel: true, // grid区域是否包含坐标轴的刻度标签。
        },
        series: [
          {
            name: 'UV',
            type: 'line',
            smooth: false, // true 为平滑曲线，false为直线
            // smooth:true,  //这个是把线变成曲线
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                // {
                //   offset: 0,
                //   color: "rgba(82,92,187,0)",
                // },
                {
                  offset: 1,
                  color: 'rgba(82,92,187)',
                },
              ]),
            },
            lineStyle: {
              color: 'rgba(82,92,187)',
              width: 1,
            },
            itemStyle: {
              color: 'rgba(82,92,187)',
            },
            data: [],
          },
          {
            name: 'PV',
            type: 'line',
            smooth: false, // true 为平滑曲线，false为直线
            lineStyle: {
              color: 'rgba(131,196,109)',
              width: 1,
            },
            itemStyle: {
              color: 'rgba(131,196,109)',
              areaStyle: {
                // color: '#94C9EC'
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  // {
                  //   offset: 0,
                  //   color: "rgba(131,196,109,0)",
                  // },
                  {
                    offset: 1,
                    color: 'rgba(131,196,109)',
                  },
                ]),
              },
            },
            data: [],
          },
        ],
      };

      if (this.queryData.time) {
        this.queryData.startTime = this.queryData.time[0];
        this.queryData.endTime = this.queryData.time[1];
      }
      let dateArr = utils.getDayAll(
        this.queryData.startTime,
        this.queryData.endTime,
        '-'
      );

      // 不展示今天的数据
      const date = new Date();
      dateArr = dateArr.filter(
        (item) => item != date.toLocaleDateString().replace(/\//g, '-')
      );
      const xData = [];
      const pvData = [];
      const uvData = [];

      const newArr = [];
      for (let i = 0; i < dateArr.length; i++) {
        newArr.push({
          dateStr: dateArr[i],
          pvCount: 0,
          uvCount: 0,
        });
      }
      newArr.forEach((item, index) => {
        this.pvuvData.forEach((item1) => {
          if (item.dateStr == item1.createDay) {
            newArr[index].pvCount = item1.pv;
            newArr[index].uvCount = item1.uv;
          }
        });
      });

      newArr.forEach((item) => {
        xData.push(item.dateStr);
        pvData.push(item.pvCount);
        uvData.push(item.uvCount);
      });

      option.xAxis.data = xData;
      option.series[0].data = pvData;
      option.series[1].data = uvData;
      this.myChart2 = this.$echarts.init(document.getElementById('myChart2'));
      this.myChart2.setOption(option);
    },

    randomData() {
      return Math.round(Math.random() * 1000);
    },

    // 查询pvuv
    changeMallPvUv(row) {
      this.pvuvData = this.mallPvUv.find(
        (item) => item.brandMallName == row
      ).pvuvList;
      this.myChartsOptionFun2();
    },

    myChartsOptionFun3() {
      const yMax = 1000;
      const dataShadow = [];
      // 订单总金额
      const orderAmount = this.saleProvince.map((item) => {
        dataShadow.push(yMax);
        return {
          name: item.provinceName,
          value: item.orderAmount,
        };
      });

      orderAmount.sort(NumAsceSort);
      // 展示前10个
      const titledata = orderAmount.map((item) => item.name);
      let newOrderAmount = [];
      let newTitledata = [];
      if (orderAmount.length > 10) {
        newOrderAmount = orderAmount.slice(
          orderAmount.length - 9,
          orderAmount.length
        );
        newTitledata = titledata.slice(
          orderAmount.length - 9,
          orderAmount.length
        );
      } else {
        newOrderAmount = orderAmount;
        newTitledata = titledata;
      }

      function NumAsceSort(a, b) {
        return a.value - b.value;
      }
      const option = {
        layoutCenter: ['72%', '60%'], // 位置, //位置
        layoutSize: `${this.mapLayoutSize}%`, // 大小
        tooltip: {
          trigger: 'item',

          formatter: (params) => {
            if (params.data) {
              return `${params.seriesName}<br>${params.marker}${params.data.name}&nbsp;&nbsp;&nbsp;&nbsp;${params.data.value} 元`;
            }
          },
        },
        legend: {
          show: false,
        },
        grid: {
          // 仅仅控制条形图的位置
          show: true,
          containLabel: false,
          left: 70,
          top: 50,
          bottom: 30,
          width: '40%',
        },
        visualMap: {
          type: 'continuous',
          min: 0,
          left: 'right',
          max: orderAmount[orderAmount.length - 1]?.value || 100,
          text: ['High', 'Low'],
          seriesIndex: [0, 2],
          dimension: 0,
          realtime: false,
          itemWidth: 18,
          itemHeight: 100,
          calculable: true,
          inRange: {
            color: ['rgba(212,242,252)', 'rgba(34,71,181)'],
            symbolSize: [100, 100],
          },
          outOfRange: {
            color: ['#eeeeee'],
            symbolSize: [100, 100],
          },
        },
        toolbox: {
          show: false,
        },

        xAxis: [
          {
            type: 'value',
            position: 'bottom',
            inside: true,
            axisLabel: {
              show: true,
            },
            splitLine: {
              show: true,
            },
            margin: 10,
            data: titledata,
          },
        ],
        yAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              show: true,
            },
            axisLabel: {
              align: 'right',
              margin: 10,
              showMaxLabel: true,
            },
            data: newTitledata,
          },
        ],

        series: [
          {
            name: '订单总金额',
            type: 'map',
            map: 'china',
            left: '100',
            width: '60%',
            roam: false,
            mapValueCalculation: 'sum',
            zoom: 1,
            selectedMode: false,
            showLegendSymbol: false,
            label: {
              color: '#666',
              itemStyle: {
                color: 'rgba(34,71,181)',
              },
            },
            itemStyle: {
              areaColor: '#EEEEEE',
              borderColor: '#FFFFFF',

              emphasis: {
                areaColor: '#E5F39B',
              },
            },
            data: orderAmount,
          },
          {
            name: '背景',
            type: 'bar',
            roam: false,
            visualMap: false,
            itemStyle: {
              color: '#eeeeee',
              opacity: 0.5,
            },
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                color: '#eeeeee',
                opacity: 0.5,
              },
              label: {
                show: false,
              },
            },
            silent: true,
            barWidth: 30,
            barGap: '-100%',
            data: dataShadow,
            animation: false,
          },
          {
            name: '订单总金额',
            type: 'bar',
            roam: false,
            visualMap: false,
            // itemStyle: {
            //   color: "#60ACFC"
            // },
            barWidth: 30,
            label: {
              show: false, // 是否在柱状图表格上展示数据
              fontSize: 12,
              position: 'insideLeft',

              itemStyle: {
                show: false, // 是否在柱状图表格上展示数据
              },
            },
            data: newOrderAmount,
          },
        ],
      };

      this.myChart3 = this.$echarts.init(document.getElementById('myChart3'));
      this.myChart3.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.data-header-box {
  display: flex;
  justify-content: space-between;
  height: 120px;
}
.data-header-li {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;

  .data-li-top {
    width: 100%;
    height: 40px;
    background: #5b85f7;
    color: #fff;
    display: flex;
    box-sizing: border-box;
    padding: 0 10px;
    align-items: center;
  }
  .data-li-content {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-around;
    .li-text {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      .text-h2 {
        color: #333;
        font-size: 16px;
      }
      .text-p {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 14px;
      }
    }
  }
}
.data-header-li:nth-of-type(1) {
  width: 42%;
}
.data-header-li:nth-of-type(2) {
  width: 32%;
}
.data-header-li:nth-of-type(3) {
  width: 22%;
}
.myChart {
  display: flex;
  flex-direction: column;
}
.region {
  width: 100%;
  height: 600px;
  position: relative;
}
.myChart3-btn {
  position: absolute;
  top: 464px;
  left: 700px;
  width: 36px;
  height: 120px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 10px;
  .btn-li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    color: #999;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }
}

.flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .flex-h2 {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333;
  }
  .icon-list {
    width: 20px;
    height: 20px;
    display: block;
    margin-right: 4px;
  }
  .btn {
    height: 32px;
  }
}
::v-deep .el-range-separator {
  width: 7%;
}
.title-text {
  width: 12px;
  height: 12px;
  font-size: 10px;
  border-radius: 50%;
  margin-left: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #999;
  color: #fff;
}
</style>
